import axios from 'axios';

/**
 * LA CHAT DI ASSISTENZA dal sito: il cliente scrive dalla bolla in basso a
 * destra, gli operatori rispondono dal backoffice o dal loro bot Telegram.
 * notification-service la tiene, il gateway la espone sotto /api/assistenza
 * (vedi AssistenzaController nel postino).
 *
 *   GET  /api/assistenza/mia              -> {accesa, attesaMinuti, conversazione, messaggi}
 *   POST /api/assistenza/mia/messaggi     {testo}
 *   POST /api/assistenza/mia/letta
 *   GET  /api/assistenza/mia/non-letti    -> {nonLetti, accesa}
 *   GET  /api/assistenza/mie              -> le chat passate
 *   GET  /api/assistenza/mie/{id}
 *
 * Il tempo reale (flusso) si apre SOLO mentre la chat e' aperta sullo
 * schermo: un cliente che naviga il sito non tiene linee aperte
 * (lvc-docs/it/tempo-reale.md). A chat chiusa basta il numero sulla bolla.
 */

function radice() {
  const env = typeof window !== 'undefined' && window.env ? window.env : {};
  return env.REACT_APP_API_URL || 'http://localhost:9001';
}

const base = () => radice() + '/api/assistenza';

function intestazioni() {
  const h = { 'Content-Type': 'application/json', 'X-Client-Surface': 'FRONTEND' };
  const token = window.localStorage.getItem('access_token');
  if (token) h.Authorization = `Bearer ${token}`;
  const tenant = window.env && window.env.REACT_APP_API_TENANT;
  if (tenant) h.TENANT_ID = tenant;
  return h;
}

export async function miaChat() {
  const r = await axios.get(`${base()}/mia`, { headers: intestazioni() });
  return r.data || { accesa: false, messaggi: [] };
}

export async function scrivi(testo) {
  const r = await axios.post(`${base()}/mia/messaggi`, { testo }, { headers: intestazioni() });
  return r.data;
}

export async function segnaLetta() {
  await axios.post(`${base()}/mia/letta`, null, { headers: intestazioni() });
}

export async function nonLetti() {
  const r = await axios.get(`${base()}/mia/non-letti`, { headers: intestazioni() });
  return r.data || { nonLetti: 0, accesa: false };
}

export async function chatPassate() {
  const r = await axios.get(`${base()}/mie`, { headers: intestazioni() });
  return Array.isArray(r.data) ? r.data : [];
}

export async function chatPassata(id) {
  const r = await axios.get(`${base()}/mie/${encodeURIComponent(id)}`, { headers: intestazioni() });
  return r.data;
}

const PAUSE_MS = [1000, 2000, 4000, 8000, 15000, 30000];

/**
 * La linea col postino mentre la chat e' aperta. `spinta` si chiama a ogni
 * CHAT_CAMBIATA: e' un «rileggi», non il dato. Restituisce la funzione che
 * chiude. La riconnessione e' nostra, con un biglietto nuovo: quella di
 * EventSource riaprirebbe il biglietto gia' bruciato.
 */
export function apriLinea(spinta, statoCambiato) {
  let acceso = true;
  let es = null;
  let timer = null;
  let tentativo = 0;

  function riprova() {
    if (!acceso) return;
    const pausa = PAUSE_MS[Math.min(tentativo, PAUSE_MS.length - 1)];
    tentativo += 1;
    timer = setTimeout(apri, Math.round(pausa * (0.7 + Math.random() * 0.6)));
  }

  async function apri() {
    if (!acceso || typeof window.EventSource === 'undefined') return;
    let biglietto;
    try {
      const r = await axios.post(`${base()}/flusso/biglietto`, null,
          { headers: intestazioni(), params: { lato: 'sito' } });
      biglietto = r.data && r.data.biglietto;
    } catch (e) {
      if (statoCambiato) statoCambiato(false);
      riprova();
      return;
    }
    if (!acceso || !biglietto) return;
    es = new window.EventSource(`${base()}/flusso/canale?biglietto=${encodeURIComponent(biglietto)}`);
    es.addEventListener('APERTO', () => { tentativo = 0; if (statoCambiato) statoCambiato(true); spinta(); });
    es.addEventListener('CHAT_CAMBIATA', () => spinta());
    es.onerror = () => {
      if (es) es.close();
      es = null;
      if (!acceso) return;
      if (statoCambiato) statoCambiato(false);
      riprova();
    };
  }

  apri();
  return () => {
    acceso = false;
    if (es) es.close();
    if (timer) clearTimeout(timer);
  };
}
